type ErrorMessage = {
  header?: string;
  message?: string;
  showButton?: "backToHomepage" | "signOut";
};
export type ErrorText = {
  [key: string]: ErrorMessage;
};

export const errorText: ErrorText = {
  "ExportButton.NoData": {
    message: "No data available to export.",
  },
  "CopyLink.Failed": {
    message: "Failed to copy link",
  },
  "Auth.NoOrganization": {
    header: "No organization found",
    message:
      "You're not currently assigned to an organization. Please contact your organization administrator to request access.",
    showButton: "signOut",
  },
  "Auth.InvalidOrganization": {
    header: "Invalid organization",
    message: "You are not a member of this organization.",
    showButton: "signOut",
  },
  "Error.NotFound": {
    header: "Oops! Something went wrong.",
    message:
      "It looks like the page didn't load properly. Please try again in a moment. If the problem persists, please contact Support.",
    showButton: "backToHomepage",
  },
  "Audio.Error": {
    message: "Error playing audio",
  },
  default: {
    message: "Something went wrong. Please try again later.",
  },
};
